import React from "react";
import {connect} from "react-redux";
import {AppState} from "../../RootReducer";
import Loader from "../../layout/Loader";
import {DepositResult, DepositResultCode} from "../../http/protocol";
import {Redirect} from "react-router-dom";
import "./styles/Deposit.scss";
import {t} from "../../i18n";
import {BrandA} from "../buttons/buttons";


interface Props {
    depositResult?: DepositResult;
}

interface State {
    startPlaying: boolean
}

export class DepositResultView extends React.Component<Props,State>{
    constructor(props:Props) {
        super(props);
        this.state = {startPlaying:false}
    }

    componentDidMount(): void {

    }

    onClick() {
        this.setState({startPlaying:true})
    }

    render() {
        if(this.state.startPlaying) {
            return <Redirect to={"/poker"} />
        }
        if(this.props.depositResult == undefined) {
            return <Loader/>
        } else {
            return(
                <div className="deposit-form">
                    {this.props.depositResult.result == DepositResultCode.OK && (
                        <div>
                            <div className="deposit-form top-text-mobile text-center">{t(`payments.result.${DepositResultCode.OK}.label`)}</div>
                            <p style={{textAlign:'center'}}>{t(`payments.result.${DepositResultCode.OK}.message`)}</p>
                        </div>
                    )}
                    {this.props.depositResult.result == DepositResultCode.DECLINED && (
                        <div>
                            <div className="deposit-form top-text-mobile text-center">{t(`payments.result.${DepositResultCode.DECLINED}.label`)}</div>
                            <p style={{textAlign:'center'}}>{t(`payments.result.${DepositResultCode.DECLINED}.message`)}</p>
                        </div>
                    )}
                    {this.props.depositResult.result == DepositResultCode.ERROR && (
                        <div>
                            <div className="deposit-form top-text-mobile text-center">{t(`payments.result.${DepositResultCode.ERROR}.label`)}</div>
                            <p style={{textAlign:'center'}}>{t(`payments.result.${DepositResultCode.ERROR}.message`)}</p>
                        </div>
                    )}
                    {this.props.depositResult.result == DepositResultCode.ACCOUNT_ALREADY_EXISTS && (
                        <div>
                            <div className="deposit-form top-text-mobile text-center">{t(`payments.result.${DepositResultCode.ACCOUNT_ALREADY_EXISTS}.label`)}</div>
                            <p style={{textAlign:'center'}}>{t(`payments.result.${DepositResultCode.ACCOUNT_ALREADY_EXISTS}.message`)}</p>
                        </div>
                    )}
                    {this.props.depositResult.result == DepositResultCode.OVER_LIMIT && (
                        <div>
                            <div className="deposit-form top-text-mobile text-center">{t(`payments.result.${DepositResultCode.OVER_LIMIT}.label`)}</div>
                            <p style={{textAlign:'center'}}>{t(`payments.result.${DepositResultCode.OVER_LIMIT}.label`)}</p>
                        </div>
                    )}
                    <div className={"deposit-form summary"}>
                        {(this.props.depositResult.result == DepositResultCode.ACCOUNT_ALREADY_EXISTS || this.props.depositResult.result == DepositResultCode.OVER_LIMIT ) && <p>Please contact customer support for assistance.</p>}
                        {this.props.depositResult.paymentId && <label className="deposit-form label">Payment ID</label>}
                        {this.props.depositResult.paymentId && <p>{this.props.depositResult.paymentId}</p>}
                        {this.props.depositResult.paymentUid && <label className="deposit-form label">Payment UID</label>}
                        {this.props.depositResult.paymentUid && <p>{this.props.depositResult.paymentUid}</p>}
                        {this.props.depositResult.referenceId && <label className="deposit-form label">Reference ID</label>}
                        {this.props.depositResult.referenceId && <p>{this.props.depositResult.referenceId}</p>}
                    </div>

                    <BrandA onClick={() => this.onClick()} className={"btn btn-cta full-width large"}>Start Playing</BrandA>
                </div>
            )
        }
    }

}

const mapStateToProps = ({payments} : AppState) => ({
    depositResult : payments.deposit.depositResult
});


export default connect(mapStateToProps)(DepositResultView);